// A class to display the character limit which updates as you type.
export default class CharacterLimitController {
  constructor(input) {
    // Find the input
    this.input = input;
    // Create a label element
    this.label = document.createElement('span');
    // Grab the limit from the maxlength attribute
    this.limit = input.getAttribute('maxlength') || false;

    // make sure we have an input with a character limit
    if (this.limit && this.input) {
      this.init();
    }
  }
  init() {
    // Give the label a class name so we can style it
    this.label.className = 'character-limit';
    // Add the label to the DOM
    this.input.parentNode.appendChild(this.label);
    // When the input value changes we need to update the character limit label
    this.input.addEventListener('input', () => this.update());
    // Initialise the label content
    this.update();
  }
  update() {
    // Make sure everything has initialised properly
    if (this.limit && this.input) {
      // Calculate the remaining characters
      this.remaining = this.limit - this.input.value.length;
      // Display the remaining characters in the label
      this.label.innerHTML = `(${this.remaining})`;
      // If the remaining characters is less than 1
      this.label.classList.toggle('character-limit--warning', this.remaining === 0);
    }
  }
}